module.exports = __webpack_public_path__ + "static/img/fruits_coconuts.913864f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_coconuts.png
// module id = U6/L
// module chunks = 1